import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'EditorResult',
    component: () => import('../views/EditorResult.vue'),
  },
  {
    path: '/UserResult/:answerGroupId',
    name: 'UserResult',
    component: () => import('../views/UserResult.vue'),
  },
  {
    path: '/no-data',
    name: 'NoData',
    component: () => import('../views/NoData.vue'),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
